import { WHATSAPP_URL } from "@/lib/site";
import { TESTIDS } from "@/lib/site";
import { trackWhatsAppClick } from "@/lib/analytics";

/**
 * Elegant floating WhatsApp CTA, bottom-right.
 * Uses brand-aware soft styling (not the typical neon green badge).
 */
export default function WhatsAppFab() {
  return (
    <a
      data-testid={TESTIDS.whatsappFab}
      id="whatsapp-fab"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Escribir por WhatsApp"
      onClick={() => trackWhatsAppClick("floating_fab")}
      className="fixed z-40 bottom-5 right-5 md:bottom-7 md:right-7 group inline-flex items-center gap-3 rounded-full bg-[#25D366] text-white pl-3 pr-4 py-2.5 md:pl-3.5 md:pr-5 md:py-3 shadow-lg shadow-[#25D366]/30 hover:shadow-xl hover:shadow-[#25D366]/40 hover:-translate-y-0.5 transition-all duration-300"
    >
      <span className="inline-flex w-9 h-9 md:w-10 md:h-10 rounded-full bg-white/15 items-center justify-center">
        {/* WhatsApp glyph */}
        <svg viewBox="0 0 32 32" className="w-6 h-6 md:w-7 md:h-7" fill="currentColor" aria-hidden>
          <path d="M19.11 17.27c-.28-.14-1.65-.81-1.9-.9-.26-.1-.44-.14-.62.14-.18.28-.71.9-.87 1.08-.16.18-.32.2-.6.07-.28-.14-1.18-.43-2.25-1.38-.83-.74-1.39-1.65-1.55-1.93-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.49.14-.16.18-.28.28-.46.09-.18.05-.34-.02-.49-.07-.14-.62-1.49-.85-2.05-.22-.54-.45-.46-.62-.47l-.53-.01c-.18 0-.46.07-.7.34-.24.28-.92.9-.92 2.2 0 1.3.94 2.55 1.07 2.73.13.18 1.85 2.82 4.49 3.96.63.27 1.12.43 1.5.55.63.2 1.21.17 1.66.1.51-.08 1.65-.67 1.88-1.32.23-.65.23-1.2.16-1.32-.07-.12-.25-.18-.53-.32z"/>
          <path d="M27.21 4.77C24.21 1.77 20.23.12 16 .12 7.28.12.2 7.2.2 15.92c0 2.78.73 5.49 2.1 7.88L.07 31.93l8.32-2.19a15.74 15.74 0 0 0 7.6 1.93h.01c8.71 0 15.79-7.08 15.79-15.79 0-4.22-1.65-8.18-4.59-11.11zM16 29.04h-.01a13.07 13.07 0 0 1-6.66-1.82l-.48-.28-4.94 1.3 1.32-4.81-.31-.49a13.04 13.04 0 0 1-1.99-6.92c0-7.22 5.87-13.09 13.09-13.09 3.5 0 6.78 1.37 9.25 3.84a13.02 13.02 0 0 1 3.83 9.26c0 7.22-5.87 13.09-13.1 13.09z"/>
        </svg>
      </span>
      <span className="hidden sm:flex flex-col text-left leading-tight">
        <span className="text-[0.65rem] uppercase tracking-[0.2em] opacity-90">
          Escríbeme
        </span>
        <span className="font-medium text-sm">por WhatsApp</span>
      </span>
    </a>
  );
}
